import React from 'react';
import { Skeleton } from './ui';

/**
 * Full-page skeleton shown as a Suspense fallback while
 * lazy-loaded route chunks are being fetched.
 */
const PageSkeleton: React.FC = () => {
  return (
    <div className="flex min-h-screen">
      {/* Sidebar placeholder (hidden on mobile) */}
      <div className="hidden lg:block w-64 border-r border-gray-200 bg-white p-4 space-y-4">
        <Skeleton height={32} className="w-3/4" />
        <div className="space-y-2 pt-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} height={28} className="w-full" />
          ))}
        </div>
      </div>

      {/* Main content placeholder */}
      <div className="flex-1 p-6 space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <Skeleton height={28} className="w-48" />
          <Skeleton height={36} className="w-32" />
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="rounded-xl bg-white p-4 shadow-sm space-y-2">
              <Skeleton height={16} className="w-24" />
              <Skeleton height={24} className="w-32" />
            </div>
          ))}
        </div>

        {/* Content area */}
        <div className="rounded-xl bg-white p-6 shadow-sm space-y-4">
          <Skeleton height={20} className="w-40" />
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} height={44} className="w-full" />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PageSkeleton;
